import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const separatorSelector = '& > :not(:last-child)::after';
const separatorVerticalInset = '4px';

const styles = {
  container: {
    padding: '4px',
  },

  rowContainer: {
    minWidth: '160px',
  },

  itemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    [separatorSelector]: {
      content: '""',
      position: 'absolute',
      top: separatorVerticalInset,
      bottom: separatorVerticalInset,
      right: '-4px',
      width: '1px',
    },
  },

  separatorColor: (variant: string) =>
    ({
      [separatorSelector]: {
        backgroundColor: `admin.${variant}`,
      },
    }),
} satisfies Record<string, SxProps<Theme> | ((variant: string) => SxProps<Theme>)>;

export default styles;
